const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const LightHelmet = require('../../../game_items/equipment/helmet/LightHelmet.js');
const LightTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const LightBoots = require('../../../game_items/equipment/boots/LightBoots.js');
const Staff = require('../../../game_items/equipment/weapon/Staff.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const kobold_cleric = (level) => {
  const handle = 'kobold_cleric';
  const types = ['healer', 'humanoid', 'kobold', 'magic'];
  const AI_PRIORITIES = ['support', 'dps_close', 'tank', 'interference', 'dps_ranged'];
  const bags = [
    {
      items: [
        ItemGenerator.getCavernsMobItem(LightHelmet, level),
        ItemGenerator.getCavernsMobItem(LightTorsoe, level),
        ItemGenerator.getCavernsMobItem(LightBoots, level),
        ItemGenerator.getCavernsMobItem(Staff, level),
      ].map((item) => ({ value: item })),
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'kobold_cleric_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          healing_prayer: {
            handle: 'healing_prayer',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          mystic_focus: {
            handle: 'mystic_focus',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          bless: {
            handle: 'bless',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      perception: Math.round(5 + bound_level * 0.6 + Math.random() * 3),
      mana: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.45 + Math.random() * 3),
      strength: Math.round(4 + bound_level * 0.35 + Math.random() * 3),
      willpower: Math.round(9 + bound_level * 1.1 + Math.random() * 3),
      dexterity: Math.round(5 + bound_level * 0.6 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 750,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'healing_prayer' },
        { value: 'mystic_focus' },
        { value: 'bless' },
      ],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = kobold_cleric;
